import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Book, Palette, Gamepad2, ShoppingBag } from 'lucide-react';
import { categories } from '../data/mockData';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const iconMap = {
  BookOpen,
  Book,
  Palette,
  Gamepad2,
  ShoppingBag
};

const FeaturedCategories = () => {
  const [ref, isVisible] = useIntersectionObserver({ once: true, threshold: 0.1 });

  return (
    <section ref={ref} className="py-16 bg-muted/30">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Categorías Destacadas</h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Explora nuestra amplia selección de productos
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category, index) => {
            const Icon = iconMap[category.icon];
            return (
              <motion.a
                key={category.id}
                href={category.link}
                custom={index}
                initial={{ opacity: 0, y: 50 }}
                animate={isVisible ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                whileHover={{
                  scale: 1.05,
                  transition: { duration: 0.3 }
                }}
                className="relative h-72 rounded-xl overflow-hidden group cursor-pointer"
              >
                {/* Background Image */}
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                  style={{ backgroundImage: `url(${category.image})` }}
                />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

                {/* Content */}
                <div className="relative h-full flex flex-col items-center justify-center text-white p-6">
                  <div className="mb-4 p-4 bg-white/10 backdrop-blur-sm rounded-full">
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-2xl font-bold">{category.name}</h3>
                </div>

                {/* Hover Border Effect */}
                <div className="absolute inset-0 border-2 border-primary opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" />
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCategories;